export class GetEnrollmentRequest {
    EnrollmentKey: string
}